import { render, staticRenderFns } from "./HomePaciente.vue?vue&type=template&id=85efd81a&scoped=true&"
import script from "./HomePaciente.vue?vue&type=script&lang=ts&"
export * from "./HomePaciente.vue?vue&type=script&lang=ts&"
import style0 from "./HomePaciente.vue?vue&type=style&index=0&id=85efd81a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85efd81a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
